import { refreshCartFragments } from "../../utils/cart-fragments";

export default function initCartQuantity() {
    var ajaxUrl = (window.vsAssets && window.vsAssets.ajaxUrl) || '/wp/wp-admin/admin-ajax.php';

    function updateQuantity(stepper, quantity) {
        var body = new FormData();
        body.append('action', 'update_cart_item_quantity');
        body.append('cart_item_key', stepper.dataset.cartItemKey);
        body.append('quantity', quantity);
        body.append('security', stepper.dataset.nonce);

        stepper.classList.add('loading');

        fetch(ajaxUrl, { method: 'POST', body: body })
            .then(function () {
                return refreshCartFragments();
            })
            .catch(function () {
                stepper.classList.remove('loading');
            });
    }

    // La croix du side cart passe par le handler natif de WooCommerce
    // (remove_from_cart), qui déclenche removed_from_cart mais n'applique
    // aucun fragment (wc-cart-fragments n'est pas chargé) : on refresh nous-mêmes
    // pour mettre à jour le side cart et réactiver les CTA "Add to cart".
    if (window.jQuery) {
        window.jQuery(document.body).on('removed_from_cart', function () {
            refreshCartFragments();
        });
    }

    // Délégation : le stepper est dans .widget_shopping_cart_content,
    // remplacé à chaque fragment refresh.
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('.js-qty-increase, .js-qty-decrease');
        if (!btn || btn.disabled) return;

        var stepper = btn.closest('.js-qty-stepper');
        var valueEl = stepper.querySelector('.c-mini-cart__item-qty-value');
        var current = parseInt(valueEl.textContent, 10) || 1;
        // Décrémenter depuis 1 retire l'item (quantity=0 = suppression côté serveur).
        var next = btn.classList.contains('js-qty-increase') ? current + 1 : current - 1;

        if (next < 0) return;

        updateQuantity(stepper, next);
    });
}
